import axios, { AxiosInstance } from "axios";

export const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
const axiosInstance: AxiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
  },
});

export default axiosInstance;
